import Image from 'next/image';
import bgImg from '@root/src/assets/images/bgcollection.webp';

export const sharedSectionRootStyle = {
  backgroundColor: '#f4ebd9',
} as const;

export const sharedSectionOverlayStyle = {
  background:
    'linear-gradient(180deg, rgba(250,245,235,0.42) 0%, rgba(244,235,217,0.28) 50%, rgba(239,228,207,0.48) 100%), radial-gradient(circle at top right, rgba(198,168,105,0.12), transparent 28%), radial-gradient(circle at bottom left, rgba(122,158,110,0.08), transparent 30%)',
} as const;

interface SharedSectionBackgroundProps {
  priority?: boolean;
  sizes: string;
  quality?: number;
}

export function SharedSectionBackground({
  priority = false,
  sizes,
  quality = 75,
}: SharedSectionBackgroundProps) {
  return (
    <>
      <div className="pointer-events-none absolute inset-0">
        <Image
          src={bgImg}
          alt=""
          aria-hidden="true"
          fill
          priority={priority}
          fetchPriority={priority ? 'high' : undefined}
          quality={quality}
          sizes={sizes}
          className="object-cover object-center"
        />
      </div>
      <div className="pointer-events-none absolute inset-0 opacity-45" style={sharedSectionOverlayStyle} />
    </>
  );
}
